'use client'

import { QuestionIcon } from '@phosphor-icons/react'
import { Popover, PopoverContent, PopoverTrigger } from '@/ui/popover'
import { FOCUS_STYLES } from '@/ui/design-tokens'

/**
 * Help popover explaining how the unified form works.
 * Shown when the form is empty.
 */
export function FormHelpPopover() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`text-muted-foreground/60 hover:text-muted-foreground flex items-center gap-1 rounded-sm text-xs transition-colors ${FOCUS_STYLES.ringCompact}`}
        >
          <QuestionIcon className="h-3 w-3" />
          <span>How does it work?</span>
        </button>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="start" className="w-72 p-3 text-sm">
        <div className="space-y-2">
          <p className="text-foreground font-medium">Capture anything</p>
          <ul className="text-muted-foreground space-y-1.5 text-xs">
            <li>
              • <strong>Thoughts & reflections</strong> — journal your day
            </li>
            <li>
              • <strong>Tasks</strong> — things you need to remember
            </li>
            <li>
              • <strong>Movies, books, music</strong> — we&apos;ll detect and
              organize them
            </li>
            <li>
              • <strong>Voice</strong> — speak naturally, we&apos;ll transcribe
            </li>
          </ul>
          <p className="text-muted-foreground/70 pt-1 text-[11px]">
            Just start typing or use voice — we&apos;ll figure out the rest.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  )
}
